"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestTimeOffCategoryCreate = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const TIMEOFF_CREATE_MUTATION = (0, graphql_tag_1.default) `
  mutation TimeOffCategoryCreate(
    $workspace: ID!
    $data: UnavailabilityCategoryInput!
  ) {
    timeOffCategoryCreate(workspace: $workspace, data: $data) {
      id
      tag
      title
      consider
      vacation
      timeInLieu
      maxDailyMinutes
      maxYearlyDays
      maxYearlyNumber
      employeeCanRequest
      approveAutomatically
      displayWorkTimeAsDays
      customId
      archived
    }
  }
`;
const requestTimeOffCategoryCreate = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(TIMEOFF_CREATE_MUTATION, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.timeOffCategoryCreate;
};
exports.requestTimeOffCategoryCreate = requestTimeOffCategoryCreate;
